<template>
    <ShcUiNotificationWrapper
        :is-show="show"
        width="lg:w-[28.8rem] xl:w-[34.5rem] 2xl:w-[32rem]"
        margin="lg:mr-5 xl:mr-1 2xl:mr-2"
        bg-color="black"
        text-color="white"
    >
        <div class="h-14 flex items-center">
            <div class="flex grow">
                <div class="flex grow mx-4 items-center">
                    <ShcUiParagraph v-if="content" :theme="PARAGRAPH_THEME.tertiary">
                        {{ content.message.toLowerCase() }}
                    </ShcUiParagraph>
                </div>
                <div class="flex flex-row">
                    <ShcUiLink :to="checkoutUrl">
                        <ShcUiParagraph class="text-white font-semibold" :theme="PARAGRAPH_THEME.tertiary">
                            {{ $t('Bbk.notification.show').toLowerCase() }}
                        </ShcUiParagraph>
                        <ShcUiIcon
                            aria-hidden="true"
                            name="shopping_bag"
                            class="w-6 h-6 ml-2 !mt-0 flex flex-row justify-center items-center rounded-full bg-white text-black text-xl"
                        />
                    </ShcUiLink>
                </div>
            </div>
            <ShcUiNotificationClose auto-close show @notification:close="onClose" />
        </div>
    </ShcUiNotificationWrapper>
</template>

<script setup lang="ts">
    import { PARAGRAPH_THEME } from '@shc/nuxt-shc-ui-layer/components/Paragraph/paragraph'
    import type { Props } from '~/components/Shc/Ui/Notification/props'
    import { NOTIFICATION_EVENT } from '~/components/Shc/Ui/Notification/notification'

    const props = defineProps<Props>()

    const emit = defineEmits<{
        (e: typeof NOTIFICATION_EVENT.notification_close, notificationMessage: { index: number }): void
    }>()

    const show = ref(false)
    const { URL_CHECKOUT_CART } = useAppConfig()
    const { siteUrl } = useRuntimeConfig().public
    const { $i18n } = useNuxtApp()

    const checkoutUrl = `${siteUrl}/${$i18n.locale.value}${URL_CHECKOUT_CART}`

    function onClose(event: boolean) {
        show.value = event
        emit(NOTIFICATION_EVENT.notification_close, {
            index: props.id,
        })
    }
    onMounted(() => {
        setTimeout(() => {
            show.value = true
        }, 10)
    })
</script>
